import React from 'react'
import {useSelector} from 'react-redux'
import {seoTypeSelector} from '../selectors'
import SeoBannerImage from './SeoBannerImage'
import SeoText from './SeoText'

/** @param {import('./SeoHeader').SeoHeaderProps} props */
export default function SeoHeader(props) {
    const image = useSelector((state) =>
        seoTypeSelector(state, `bannerImageUrl`),
    )

    const hasImage = (src) => {
        return typeof src === `string` && !/missing/.test(src)
    }

    return hasImage(image) ? (
        <div className="store-info">
            <SeoBannerImage
                src="bannerImageUrl"
                alt="h1Text"
                className="store-info__image"
            />
            <div className="store-info__content">
                <SeoText tag="h1" type="h1Text" className="store-info__title" />
                <SeoText
                    type="regularText"
                    className="store-info__description"
                />
            </div>
        </div>
    ) : (
        <>
            <SeoText
                tag="h1"
                type="h1Text"
                className="main-slogan text-center"
            />
            <SeoText tag="h2" type="h2Text" className="slogan text-center" />
            <SeoText type="regularText" className="sub-slogan text-center" />
        </>
    )
}
